export const SET_DATA = 'offers/SET_DATA'
export const SET_IS_FETCHING = 'offers/SET_IS_FETCHING'
export const SET_TOTAL_ITEMS = 'offers/SET_TOTAL_ITEMS'
